import { useSnackbar } from 'notistack'
import { useCallback, useEffect, useState } from 'react'
import { AspenCandidatesService, CandidateDTO } from '../client'
import { CancelablePromise } from '../client/core/CancelablePromise'
export const useCandidate = (candidateId: string) => {
    const [candidate, setCandidate] = useState<CandidateDTO | null>(null)
    const [loading, setLoading] = useState<boolean>(true)
    const [error, setError] = useState<string | null>(null)
    const { enqueueSnackbar } = useSnackbar()

    const fetchCandidate = useCallback(async () => {
        setLoading(true)
        setError(null)
        try {
            const response: CancelablePromise<CandidateDTO> = AspenCandidatesService.getCandidatesCandidateIdGet({ candidateId })
            const data = await response
            setCandidate(data)
        } catch (err) {
            setError('Failed to fetch candidate data')
            enqueueSnackbar('Failed to fetch candidate data', { variant: 'error' })
        } finally {
            setLoading(false)
        }
    }, [candidateId, enqueueSnackbar])

    useEffect(() => {
        fetchCandidate()
    }, [fetchCandidate])

    const updateCandidateStatus = useCallback(
        async (status: 'allocated' | 'allocated_group_2' | 'allocated_group_3' | 'declined' | 'candidate') => {
            setLoading(true)
            setError(null)
            try {
                const response: CancelablePromise<CandidateDTO> = AspenCandidatesService.patchCandidatesCandidateIdPatch({
                    candidateId,
                    requestBody: { status, id: candidateId }
                })
                const data = await response
                setCandidate(data)
                enqueueSnackbar('Success', { variant: 'success' })
            } catch (err) {
                setError('Failed to update candidate status')
                enqueueSnackbar(`Error updating candidate status: ${err}`, { variant: 'error' })
            } finally {
                setLoading(false)
            }
        },
        [candidateId, enqueueSnackbar]
    )

    return { candidate, loading, error, fetchCandidate, updateCandidateStatus }
}
